import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import MultistringUtils from 'libraries/MultistringUtils';

import { AppError } from 'app/common/app-error';
import { BadInput } from 'app/common/bad-input';
import { SignMessRequestsBo } from 'bll/SignMessRequestsBo';
import { BadWords } from 'domain-models/BadWords';
import { FontCharacters } from 'domain-models/FontCharacters';
import { Fonts } from 'domain-models/Fonts';
import { SignInfo } from 'domain-models/SignInfo';
import { SignPriorities } from 'domain-models/SignPriorities';
import { environment } from 'environments/environment';
import { Helper } from 'libraries/Helper';
import { Line } from 'libraries/Line';
import { Page } from 'libraries/Page';
import { SelectItem } from 'libraries/SelectItem';
import { ConfirmationService } from 'primeng/primeng';
import { AuthService } from 'services/auth/auth.service';
import { BadWordsService } from 'services/bad-words/bad-words.service';
import { FontsService } from 'services/fonts/fonts.service';
import { SignInfoService } from 'services/sign-info/sign-info.service';
import { SignPrioritiesService } from 'services/sign-priorities/sign-priorities.service';
import { SignMessRequestsService } from 'services/signMessRequests/sign-mess-requests.service';
import { UserInfoService } from 'services/user-info/user-info.service';
import swal from 'sweetalert2';
declare var msal: any; //this is set from the CDN
declare var $: any;

@Component({
	selector: 'app-dms-control',
	templateUrl: './dms-control.component.html',
	styleUrls: ['./dms-control.component.css']
})
export class DmsControlComponent implements OnInit {
	msalInstance = new msal.PublicClientApplication(environment.azureAD.msalConfig); //instantiate msal
	//patch fo redirecting multiple times****
	overviewPageHasBeenCalled = false;

	// Class Variables
	loading: boolean = false;
	pages: Array<Page>; //Pages available for a sign. This array is used to display page1, page2, and page3
	tempPages: Array<Page>; //tempPages keeps the value of pages in case the user deselct all the locations (signInfo), and that way allows you to recover it
	activePage: Page = new Page(); //The page that the user si currently changing
	maximumLength: number = 0; //the maximum length the user can type based on a font ad a signInfo
	badWords: Array<BadWords>;
	isAdmin: boolean;

	selectedDuration: any; //String representing the duration the user selected
	choosenDate: Date; //date selected on duration when user clicks Timed

	beaconsValue: boolean = false; //Boolean representing weather the user selected or no the beacons

	fonts: Array<Fonts>; //use to store what you get from the http request and to populate fontsDropdownList
	fontsDropdownList: SelectItem[] = new Array(); //Fonts array with all the values of the fonts
	selectedFont: Fonts; //The font chosen from the dropdown
	fontCharacters: Array<FontCharacters>; //use to save the values from the http request

	signInfoList: Array<SignInfo> = new Array(); //Used to save the value you get from http request, and to populate the dropdown
	signInfoDropdownList: Array<SelectItem> = new Array<SelectItem>(); //List used to populate the multi-select-component
	selectedSignInfo: Array<SignInfo> = new Array();

	signPriorities: Array<SignPriorities>; //Used to save the value you get from http request, and to populate the dropdown
	signPrioritiesDropdownList: Array<SelectItem> = new Array<SelectItem>(); //List used to populate the prioirty dropdown
	selectedPriority: SignPriorities; //The priority chosen from the dropdown list

	shouldType: boolean;
	FullDetail: boolean = false;

	oneFontSignSelected: boolean = false; //This is a flag to know if Adco sign in Boise city is selected
	selectedShortestSignHeight; //Used to keep the number of lines needed after clearing all text
	/**
	 * Used for password confirmation when the user is trying to save a message that contains a bad word
	 */
	p: string;

	/**
	 *
	 * @param signPrioritiesService
	 * @param signInfoService
	 * @param fontsService
	 * @param signMessRequestsService
	 * @param route
	 * @param badWordsService
	 */
	constructor(
		private signPrioritiesService: SignPrioritiesService,
		private signInfoService: SignInfoService,
		private fontsService: FontsService,
		private signMessRequestsService: SignMessRequestsService,
		private route: ActivatedRoute,
		private badWordsService: BadWordsService,
		private router: Router,
		private authService: AuthService,
		private userInfoService: UserInfoService,
		private confirmationService: ConfirmationService
	) {
		// Initialize
		this.fontsDropdownList = [];
		this.signInfoDropdownList = [];
		this.selectedDuration = 'Timed';
		this.signPrioritiesDropdownList = [];
		this.signPrioritiesDropdownList.push({ label: 'Select Priority', value: null });
	}

	/**
	 * Method to initialize new empty lines for all pages
	 * You can use this when you need to clear the content off all the pages or
	 * to initilize a new instance
	 * @param numberOfLines number of lines per page
	 */
	createEmptyPages(numberOfLines: number = 3) {
		if (this.pages) {
			this.tempPages = [...this.pages];
		}
		const pages = new Array<Page>(3);

		pages[0] = new Page(numberOfLines, 1);
		pages[1] = new Page(numberOfLines, 2);
		pages[2] = new Page(numberOfLines, 3);

		this.activePage = pages[0];

		this.pages = pages;
	}

	adjustNumberOfLines(numberOfLines: number) {
		if (this.pages) {
			this.tempPages = [...this.pages];
		}

		for (const page of this.pages) {
			// If there are too many lines, remove extras
			if (page.lines.length > numberOfLines) {
				page.lines = page.lines.slice(0, numberOfLines);
			} else if (page.lines.length < numberOfLines) {
				// Use an existing line as a basis
				const line = { ...page.lines[0] };
				line.characterPixelCount = 0;
				line.justifications = {};
				line.text = '';

				// Add lines up to the required number
				for (let index = page.lines.length; index < numberOfLines; index++) {
					page.lines.push({ ...line } as Line);
				}
			}
		}
	}

	assignFonts() {
		this.pages.forEach((page) => {
			page.font = this.selectedFont;
			page.lines.forEach((line) => {
				line.font = this.selectedFont;
			});
		});
	}

	/**
	 * Call all the request to populate the data on the page
	 */
	async ngOnInit() {
		this.authService.updateLogStatus();

		let canWrite = await this.authService.checkWriteAccess();
		if (!canWrite) {
			return;
		}

		this.createEmptyPages(3);

		this.userInfoService.getValue(this.authService.currentUser.username).subscribe((results) => {
			let userLevel = results[0].user_level;
			this.isAdmin = userLevel === 1;
		});

		this.fontsService.getAll().subscribe((result) => {
			this.fonts = result;
			this.fonts.forEach((element) => {
				this.fontsDropdownList.push({ label: element.Name, value: element });

				this.fontsService.getByValue('fontCharacters/' + element.Id, '').subscribe(
					(result) => {
						this.fontCharacters = result;
						localStorage.setItem('fontCharacters' + '-' + element.Id, JSON.stringify(result));
						// this.fontCharacters.forEach(element => {
						//   console.log(element.Id + "," + element.AsciiValue + "," + element.WidthInPixels + "," + element.FontId);
						// });
					},
					(error: AppError) => {
						if (error instanceof BadInput) {
						}
					}
				);
			});
			this.selectedFont = this.fonts[1];
			this.assignFonts();
			//console.log(this.fonts);
		});

		this.signPrioritiesService.getAll().subscribe((result) => {
			this.signPriorities = result;
			this.signPriorities = this.signPriorities.sort((a, b) => {
				return a.Level < b.Level ? 1 : -1;
			});
			this.signPriorities.forEach((element) => {
				this.signPrioritiesDropdownList.push({
					label: element.Level + ' - ' + element.Name,
					value: element
				});
			});
			// console.log(this.signPriorities);
		});

		this.badWordsService.getAll().subscribe((result) => {
			this.badWords = result;
			localStorage.setItem('badWords', JSON.stringify(result));
			// console.log(this.badWords); // Maybe we shouldn't log the list of badwords that we don't want them to use lol
		});

		this.signInfoService
			.getByValue('full', this.authService.currentUser.username)
			.subscribe((result) => {
				this.signInfoList = result;
				this.signInfoList.forEach((element) => {
					this.signInfoDropdownList.push({ label: element.Name, value: element });
				});

				// Select passed ids from url
				this.route.queryParams.subscribe((params) => {
					let ids = params['ids'];
					if (ids) {
						//console.log(ids);
						let selectedSigns = this.signInfoList.filter((s) => {
							return ids.some((i) => i == s.Id);
						});
						this.selectedSignInfo = selectedSigns;
						this.updateSelectedLocations(selectedSigns);
						if (this.selectedSignInfo.length === 1) {
							// TODO: Why didn't we just set this.pages equal to the result of the parse?
							let pages = MultistringUtils.parse(this.selectedSignInfo[0], this.fontsService);
							setTimeout(
								() =>
									pages.forEach((page, index) => {
										if (page.font) {
											this.pages[index].setFont(page.font.Id, this.fontsService);
										}
										page.lines.forEach((line, lineIndex) => {
											this.pages[index].lines[lineIndex].text = line.text;
											this.pages[index].lines[lineIndex].justifications = line.justifications;
											if (line.font && line.font.Id) {
												this.pages[index].lines[lineIndex].setFont(line.font.Id, this.fontsService);
											}
										});
									}),
								300 /* Obviously this number is arbitrary. MultistringUtils makes a call
                   to the fontsService, which means we have to wait to get data back.
                   There is probably a better way, but I'm just glad I figured out this was causing issues.
                   */
							);
						}
					}
				});

				// console.log(this.signPriorities);
				this.selectedDuration = 'Infinite';
			});
	}

	/**
	 * Set the page that the user is going to edit
	 * @param page the selected page by the user
	 */
	private SetActivePage(page) {
		this.authService.updateLogStatus();
		if (!this.authService.writeAccess) {
			this.authService.logout();
		}

		var stop = false;
		for (var pageIndex = 0; pageIndex < this.pages.length; pageIndex++) {
			var mypage = this.pages[pageIndex];
			if (page == mypage) {
				if ((pageIndex > 0 && !this.pages[pageIndex - 1].IsEmpty()) || pageIndex == 0) {
					this.activePage = page;
				} else {
					Helper.alert(
						'Please write a message on the previous pages before you can write on this one'
					);
				}
			}
		}
		// if(page==this.pages[0]){
		//   this.activePage = page;
		// }
		// else if(page==this.pages[1] && !this.pages[0].IsEmpty()) {
		//   this.activePage = page;
		// }
		// else if(page==this.pages[2] && !this.pages[1].IsEmpty()) {
		//   this.activePage = page;
		// }
	}

	/**
	 * Event that execute whenever the user changes the font type
	 * Used to clear the message of that line to validate the user types the nright number of characters
	 * @param font selected font
	 */
	selectedFontChange(font: Fonts) {
		this.authService.updateLogStatus();
		if (!this.authService.writeAccess) {
			this.authService.logout();
		}

		this.activePage.lines.forEach((line) => {
			if (line.isActive) {
				// Because of the way multistring is constructed,
				// we can always set the page font to whatever any of its lines' font is
				this.activePage.font = font;
				line.font = font;
				var aux = line.text;
				line.text = '';
			}
		});
	}

	getNull() {
		return null;
	}

	updateSelectedLocations(signInfos: SignInfo[]) {
		try {
			// if (previousSignInfos && signInfos.length === 1 && previousSignInfos.length === 0) {
			//   this.pages = [...this.tempPages];
			//   return;
			// }
			// Setup variables for use
			let signs = signInfos;
			// Find longest line in message
			const longestLine = this.findLongestLine(this.pages);
			// Find shortest sign width
			const { width: shortestWidth = 0, differentWidths } = this.findShortestSignWidth(signs);

			// Find shortest sign height
			const { height: shortestHeight = 3, differentHeights } = this.findShortestSignHeight(signs);
			this.selectedShortestSignHeight = shortestHeight;
			let oneFontSignSelected = this.isOneFontSignSelected(signs);

			// console.log(`Longest line: ${longestLine}`);
			// console.log(`Shortest width: ${shortestWidth}, different widths: ${differentWidths}`);
			// console.log(`Shortest height: ${shortestHeight}, different heights: ${differentHeights}`);

			if (oneFontSignSelected) {
				Helper.alert(`You've chosen a sign that only support ONE font.<br>
        ** You will not be able to change fonts.** `);
				this.oneFontSignSelected = true;
				this.changeFontsMenu(this.fonts[0]);
			} else {
				this.oneFontSignSelected = false;
			}

			// Do checking and alerts
			// If there are signs of different heights
			if (differentHeights) {
				// Alert user
				Helper.alert(`You've chosen one or more signs that have fewer lines than the others.<br>
        ** Defaulted to the shortest sign height to safely send the same message to all selected signs. **<br>
          Uncheck the signs with fewer lines to utilize the taller signs' full potential.`);
			}
			// If there are signs of different lengths
			if (differentWidths && !oneFontSignSelected) {
				// Alert user
				Helper.alert(
					`The selected signs you just selected has different size.<br>
          The maximum characters will be defaulted to the smallest sign selected. The font has been updated to Compressed 7x4.`,
					3
				);
				this.changeFontsMenu(this.fonts[1]);
			}
			// If the message is longer than the smallest width sign:
			if (longestLine > shortestWidth && signs.length > 0) {
				// Alert user
				Helper.alert(`You've chosen one or more signs that are too short for the message being edited.<br>
          Please shorten the message before trying again.`);
				// Prepare to uncheck too small signs
				signs = signs.filter((sign: SignInfo) => {
					if (sign.CharWidthPixels * sign.ModulePerLine < longestLine) {
						$(`#ckbx_${sign.Id}`).attr('checked', false);
						return false;
					} else {
						return true;
					}
				});
			}

			// Setup pages
			this.selectedSignInfo = signs;
			// Only clear the message builder if all signs were unchecked
			if (longestLine === 0 || signs.length === 0) {
				this.createEmptyPages(shortestHeight);
			} else {
				this.adjustNumberOfLines(shortestHeight);
			}
			this.assignFonts();

			// Set maximum number of pixels on each line to the shortest sign width
			this.setMaximumCharacters(shortestWidth);

			// Enable/disable typing
			if (this.selectedSignInfo.length > 0) {
				this.shouldType = true;
			} else {
				this.shouldType = false;
			}
		} catch (ex) {
			console.error(ex);
		}
	}

	findLongestLine(pages: Page[]) {
		// Check each line's characterPixelCount against the previous longest
		let longestLine = 0;
		pages.forEach((page) => {
			page.lines.forEach((line) => {
				if (line.characterPixelCount > longestLine) {
					longestLine = line.characterPixelCount;
				}
			});
		});
		return longestLine;
	}

	findShortestSignWidth(signs: SignInfo[]): { width: number; differentWidths: boolean } {
		if (!signs || signs.length < 1) {
			return { width: undefined, differentWidths: false };
		}

		// Check each sign's (CharWidthPixels * ModulePerLine) against the previous shortest
		let shortestWidth = 999;
		let differentWidths = false;
		signs.forEach((sign) => {
			const signWidth = sign.CharWidthPixels * sign.ModulePerLine;
			// Set flag if this width is *different* from previous shortest value
			if (shortestWidth !== 999 && shortestWidth !== signWidth) {
				differentWidths = true;
			}
			// Check this sign's width against previous shortest width
			if (signWidth < shortestWidth) {
				// Now overwrite the previous shortest width
				shortestWidth = signWidth;
			}
		});
		return { width: shortestWidth, differentWidths };
	}

	findShortestSignHeight(signs: SignInfo[]): { height: number; differentHeights: boolean } {
		if (!signs || signs.length < 1) {
			return { height: undefined, differentHeights: false };
		}
		// Check each sign's NumberOfLines against the previous smallest
		let shortestHeight = 999;
		let differentHeights = false;
		signs.forEach((sign) => {
			// Set flag if this height is *different* from previous shortest value
			if (shortestHeight !== 999 && shortestHeight !== sign.NumberOfLines) {
				differentHeights = true;
			}
			// Check this sign's height against previous shortest height
			if (sign.NumberOfLines < shortestHeight) {
				// Now overwrite the previous shortest height
				shortestHeight = sign.NumberOfLines;
			}
		});
		return { height: shortestHeight, differentHeights };
	}

	isOneFontSignSelected(signs: SignInfo[]): boolean {
		let oneFontSign = false;
		if (!signs || signs.length < 1) {
			return oneFontSign;
		}
		// Check if there is a sign with Model='font01'
		signs.forEach((sign) => {
			// Set flag if this height is *different* from previous shortest value
			if (sign.Model === 'font01') {
				oneFontSign = true;
			}
		});
		return oneFontSign;
	}

	setMaximumCharacters(pixels: number) {
		this.tempPages = [...this.pages];

		this.pages.forEach((page) => {
			page.lines.forEach((line) => {
				line.maximunCharacter = pixels;
			});
		});
	}

	// updateSelectedLocations(list) {
	//   this.selectedSignInfo = this.selectedSignInfo.filter(n => n);
	//   if (!this.isMobile() || this.FullDetail === true) {
	//     this.selectedSignInfo = list;
	//   }

	//   if (this.selectedSignInfo.length > 0) {
	//     if (this.selectedSignInfo.length === 1) {
	//       this.createEmptyPages(this.selectedSignInfo[0].NumberOfLines);
	//       this.assignFonts();
	//     }

	//     let messageWidth = 0;
	//     this.pages.forEach(page => {
	//       page.lines.forEach(line => {
	//         if (line.characterPixelCount > messageWidth) {
	//           messageWidth = line.characterPixelCount;
	//         }
	//       });
	//     });

	//     // Remove signs with fewer lines than the biggest
	//     let maxLines = this.selectedSignInfo[0].NumberOfLines;
	//     this.selectedSignInfo.forEach(sign => {
	//       if (sign.NumberOfLines > maxLines) {
	//         maxLines = sign.NumberOfLines;
	//       }
	//     });
	//     let tooFewLinesSigns = this.selectedSignInfo.filter(sign => {
	//       if (sign.NumberOfLines < maxLines) {
	//         return sign;
	//       }
	//     });

	//     if (tooFewLinesSigns.length > 0 && tooFewLinesSigns[0] !== undefined) {
	//       Helper.alert(`You've chosen one or more signs that have fewer lines than the others. This may cause unintended multistring issues.`);
	//       tooFewLinesSigns.forEach(i => {
	//         // This isn't working for some reason
	//         // $(`#ckbx_${i}`).trigger('click');
	//       });
	//     }

	//     const signLength = this.selectedSignInfo[0].CharWidthPixels * this.selectedSignInfo[0].ModulePerLine;
	//     var minWidth = signLength;
	//     let messageShown = false;
	//     let tooShortSigns = [];
	//     this.selectedSignInfo.forEach((sign, signIndex) => {
	//       let tempVal = sign.CharWidthPixels * sign.ModulePerLine;
	//       if (messageWidth > tempVal) {
	//         tooShortSigns.push(sign.Id);
	//         return;
	//       } else {
	//         if (tempVal < minWidth) {
	//           minWidth = tempVal;
	//         }
	//         if (signLength != tempVal && messageShown === false) {
	//           //different size selected
	//           messageShown = true;
	//           Helper.alert("The sign you just selected has different size. The maximum characters will be defaulted to the smallest sign selected. The fonts has been updated to Compressed 7x4.", 3);
	//           this.changeFontsMenu(this.fonts[1]);
	//         }
	//       }
	//     });

	//     if (tooShortSigns.length > 0) {
	//       Helper.alert(`You've chosen one or more signs that are too short for the message being edited. Please shorten the message before trying again.`);
	//       tooShortSigns.forEach(i => {
	//         $(`#ckbx_${i}`).trigger('click');
	//       });
	//     }

	//     if (this.maximumLength != minWidth) {
	//       this.maximumLength = minWidth;
	//       this.pages.forEach(page => {
	//         console.log(page);
	//         page.lines.forEach(line => {
	//           console.log(line);
	//           line.maximunCharacter = this.maximumLength;
	//         });
	//       });
	//     }
	//     this.shouldType = true;
	//   }
	//   else {
	//     this.createEmptyPages();
	//     this.shouldType = false;
	//   }
	// }

	changeFontsMenu(font: Fonts) {
		//[options]="fontsDropdownList" name="fontId" [(ngModel)]="selectedFont"

		this.selectedFont = font;
		this.pages.forEach((page) => {
			page.font = this.selectedFont;
			page.lines.forEach((line) => {
				line.font = this.selectedFont;
			});
		});
	}

	isMobile() {
		if ($(window).width() > 991) {
			return false;
		}
		return true;
	}

	submit(f) {
		//not implemented
	}

	// shouldType() {
	//   if (!this.selectedSignInfo || this.selectedSignInfo.length < 1) {
	//     return false;
	//   }
	//   return true;
	// }

	/**
	 * Post a message to the sign
	 * @param ignoreBadWords if true, the message will be posted without checking for bad words
	 * @returns
	 */
	PostMessage(ignoreBadWords: boolean = false) {
		this.authService.updateLogStatus();
		if (!this.authService.writeAccess) {
			this.authService.logout();
		}

		this.loading = true;
		if (!this.selectedSignInfo || this.selectedSignInfo.length < 1) {
			Helper.showNotification('top', 'right', 'Please select <b>one or more</b> DMS location', 4);
			this.loading = false;
			return;
		}
		if (!this.selectedPriority) {
			Helper.showNotification('top', 'right', 'Please <b>select priority</b>', 4);
			this.loading = false;
			return;
		}

		//console.log("This are your pages", this.pages);
		this.selectedSignInfo.forEach(async (element) => {
			//console.log(element.Id);

			let signMessRequests = await SignMessRequestsBo.CreateSubmitRequest(
				element.Id,
				this.selectedPriority.Id,
				this.selectedPriority.Level,
				13,
				'Send',
				this.pages,
				this.selectedDuration,
				this.choosenDate,
				this.beaconsValue,
				this.authService.currentUser.username,
				ignoreBadWords
			);

			this.signMessRequestsService.create(signMessRequests).subscribe(
				(id) => {
					//console.log("The id of the just added thing is", id);
					this.navigateToOverviewOnSucced('Your posting request has been submited succesfully');
				},
				(error: AppError) => {
					this.loading = false;
					// if we get a bad word error, we need to prompt admin users to override
					if (error instanceof BadInput && error.originalError.code === 'BAD_WORD_DETECTED') {
						if (this.authService.currentUser.is_admin) {
							// check app.component.ts for the implementation of this in the acceptBadWords and rejectBadWords methods
							this.confirmationService.confirm({
								key: 'badWord',
								message: '',
								accept: () => {
									this.PostMessage(true);
								},
								reject: () => {}
							});
						} else {
							Helper.alert(
								'Your message contains a possible banned word! Contact an ODOT admin to post this message'
							);
						}
					} else if (error instanceof BadInput)
						Helper.showNotification('top', 'right', error.originalError.message, 4);
					else throw error;
				}
			);
		});
		//console.log(f);
		//console.log(this.selectedPriority);
	}
	GetCurrentMessage() {
		this.authService.updateLogStatus();
		if (!this.authService.readAccess) {
			this.authService.logout();
		}
		console.log('getting current message');
		// Retrieve from DB
		this.selectedSignInfo.map((s) => {
			let signMessRequest = SignMessRequestsBo.CreatePollRequest(
				s.Id,
				this.authService.currentUser.username
			);
			this.signMessRequestsService.create(signMessRequest).subscribe(
				(id) => {
					//console.log("The id of the just polled thing is", id);
					this.navigateToOverviewOnSucced('Your poll request has been submited succesfully');
				},
				(error: AppError) => {
					if (error instanceof BadInput) alert('Bad input error.');
					else throw error;
				}
			);
		});
	}
	ClearSign() {
		this.authService.updateLogStatus();
		if (!this.authService.writeAccess) {
			this.authService.logout();
		}
		console.log('clearing');
		this.selectedSignInfo.map((s) => {
			let signMessRequest = SignMessRequestsBo.CreateClearRequest(
				s.Id,
				this.authService.currentUser.username
			);
			this.signMessRequestsService.create(signMessRequest).subscribe(
				(id) => {
					console.log('The id of the just added thing is', id);
					this.navigateToOverviewOnSucced('Your clear request has been submited succesfully');
				},
				(error: AppError) => {
					if (error instanceof BadInput) alert('Bad input error.');
					else throw error;
				}
			);
		});
	}

	PreviewMultistring() {
		//alert(MultistringUtils.construct(this.pages));
		swal({
			title: 'Multistring Preview:',
			text: MultistringUtils.construct(this.pages),
			buttonsStyling: false,
			confirmButtonClass: 'btn btn-success'
		});
	}

	navigateToOverviewOnSucced(message: string) {
		if (!this.overviewPageHasBeenCalled) {
			this.overviewPageHasBeenCalled = true;
			Helper.alert(message, 2);
			let group = this.route.snapshot.queryParams['redirectGroup'];
			console.log('GROUP: ' + group);
			if (group) {
				this.router.navigate(['/display'], { queryParams: { redirectGroup: group } });
			} else {
				this.router.navigate(['/display']);
			}
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/dms-control/dms-control.component.ts